/**
 * menus/type_4.js
 * theme_type = 'type_4' 전용.
 *
 * type_4 는 API(setting/header → data.menu_items)로 GNB를 구성하므로
 * HeaderNavs/ServiceNavs 를 사용하지 않습니다.
 * Header.vue 에서 type_4 판별 시 type_4/HeaderMenu.vue 를 렌더합니다.
 */

export const SITEMAPS = [];
export const MENUS = [];
